import { CQAppConstant } from "../../app-constants";
import { ICriteria } from "../../components/template-configuration/layout-configuration-panel/ILayoutConfigurationPanel.Interface";
import { BaseRuleController } from "./base-rule.controller";

export class FormRuleController extends BaseRuleController<ICriteria> {
    protected generateFilterString(criterias: ICriteria[]) {
		const criteriaFilterString: string[] = [];
		const referenceFieldInCriteria: string[] = [];
		criterias.forEach((criteria: ICriteria, index: number) => {
			const operator =
				criteria.operator !== CQAppConstant.EXISTS && criteria.operator !== CQAppConstant.ISEMPTY
					? criteria.operator
					: '';
			const fieldName = criteria.field.includes('-') ? criteria.field.split('-')[1] : criteria.field;
			let recordStr = CQAppConstant.RECORD;
			if (fieldName === 'customSettings' || fieldName === 'userInfo.Id') {
				recordStr = '';
			}
			if (criteria.isDynamic && operator !== '') {
				const compareTo = criteria.compareTo.includes('-')
					? criteria.compareTo.split('-')[1]
					: criteria.compareTo;
				let recordStrCmpTo = compareTo === 'userInfo.Id' ? '' : CQAppConstant.RECORD;
				if (CQAppConstant.REFERENCE_FIELD_TYPE.includes(criteria.selectedFieldType)) {
					if (index === 0 && criteria.referenceField === '') {
						criteriaFilterString.push(
							` ${recordStr}${fieldName} ${operator} ${recordStrCmpTo}${criteria.compareTo}`
						);
					} else {
						referenceFieldInCriteria.push(fieldName);
						criteriaFilterString.push(
							` ${recordStr}${criteria.relationshipName}.${criteria.referenceField} ${operator} ${recordStrCmpTo}${criteria.compareTo}`
						);
					}
				} else {
					criteriaFilterString.push(` ${recordStr}${fieldName} ${operator} ${recordStrCmpTo}${compareTo}`);
				}
			} else {
				let isNumber = false;
				if (criteria.compareTo === '') {
					isNumber = false;
				} else {
					isNumber = !isNaN(+criteria.compareTo);
				}

				if (CQAppConstant.REFERENCE_FIELD_TYPE.includes(criteria.selectedFieldType) && operator !== '') {
					if (index === 0 && criteria.referenceField === '') {
						criteriaFilterString.push(
							`${
								criteria.operator === CQAppConstant.ISEMPTY ? '!' : ''
							}${recordStr}${fieldName} ${operator} ${
								isNumber
									? parseInt(criteria.compareTo)
									: this.covertStringIfIBooleanType(criteria.compareTo)
							} `
						);
					} else {
						referenceFieldInCriteria.push(fieldName);
						criteriaFilterString.push(
							`${criteria.operator === CQAppConstant.ISEMPTY ? '!' : ''
                            }${recordStr}${criteria.relationshipName
							}.${criteria.referenceField} ${operator} ${
								isNumber
									? parseInt(criteria.compareTo)
									: this.covertStringIfIBooleanType(criteria.compareTo)
							} `
						);
					}
				} else {
					criteriaFilterString.push(
						`${
							criteria.operator === CQAppConstant.ISEMPTY ? '!' : ''
						}${recordStr}${fieldName} ${operator} ${
							isNumber
								? parseInt(criteria.compareTo)
								: this.covertStringIfIBooleanType(criteria.compareTo)
						} `
					);
				}
			}
		});

		return { criteriaFilterString, referenceFieldInCriteria };
	}
}